<template>
  <el-dialog title="Form Outlet" :visible="visible" width="40%" :before-close="dismis">
    <el-form :model="form">
      <el-form-item label="Region" v-if="type == 'add'">
        <el-select
          style="width: 100%"
          @change="formRegionChanged"
          v-model="form.region_code"
          placeholder="Select"
        >
          <el-option
            v-for="item in regions"
            :key="item.id"
            :label="item.text"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Branch" v-if="type == 'add'">
        <el-select
          style="width: 100%"
          @change="formBranchChanged"
          v-model="form.branch_code"
          placeholder="Select"
        >
          <el-option
            v-for="item in branches"
            :key="item.id"
            :label="item.text"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Name">
        <el-input v-model="form.name" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="Outlet Type (00-99)" v-if="type == 'add'">
        <el-input
          type="number"
          :max="99"
          @change="formTypeChanged"
          v-model="form.outlet_type"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="Code (Auto Generated : Region Code + Branch Code + Outlet Type)"
      >
        <el-input :disabled="true" v-model="form.code" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="Latitude (Opsional)">
        <el-input v-model="form.latitude" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="Longitude (Opsional)">
        <el-input v-model="form.longitude" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="Address (Opsional)">
        <el-input v-model="form.address" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="Status">
        <br />
        <el-switch
          v-model="form.is_active"
          active-text="Aktif"
          inactive-text="Non-aktif"
          :active-value="1"
          :inactive-value="0"
        >
        </el-switch>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dismis">Cancel</el-button>
      <el-button
        v-if="type == 'add'"
        type="primary"
        @click="saveOutlet()"
        :loading="loading"
        >Confirm</el-button
      >
      <el-button v-else type="primary" @click="updateOutlet()" :loading="loading"
        >Confirm</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import regions from "@/api/regions";
import branches from "@/api/branches";
import outlets from "@/api/outlets";
export default {
  props: ["visible", "form", "type"],
  data() {
    return {
      loading: false,
      regions: [],
      branches: [],
    };
  },
  mounted() {
    this.fetchRegionForEditUser();
  },
  methods: {
    dismis() {
      this.$parent.dismisFormAdd();
    },
    fetchBranchForEditUser() {
      var self = this;
      branches
        .getAll(this.form.region_code)
        .then(function (response) {
          //
          var regionsx = [];
          response.data.data.forEach((element) => {
            regionsx.push({
              id: element.code,
              text: element.name,
            });
          });
          self.branches = regionsx;
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.status == 403) {
            self.logout();
          }
        });
    },
    fetchRegionForEditUser() {
      var self = this;
      regions
        .getAll()
        .then(function (response) {
          //
          var regionsx = [];
          response.data.data.forEach((element) => {
            regionsx.push({
              id: element.code,
              text: element.name,
            });
          });
          self.regions = regionsx;
          // self.dialogForm2Visible = true
          self.fetchBranchForEditUser();
          // console.log(self.outlets)
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.status == 403) {
            self.logout();
          }
        });
    },
    formRegionChanged(val) {
      // console.log('region ganti')
      // console.log(val)
      this.form.region_code = val;
      this.form.branch_code = "";
      this.form.outlet_code = "";
      this.form.outlet_type = "";
      this.form.code = val;
      this.fetchBranchForEditUser();
    },
    formBranchChanged(val) {
      // console.log('branch ganti')
      // console.log(val)
      this.form.branch_code = val;
      this.form.outlet_code = "";
      this.form.outlet_type = "";
      this.form.code = this.form.region_code + val;
    },
    formTypeChanged(val) {
      this.form.code = this.form.region_code + this.form.branch_code + val;
    },
    saveOutlet() {
      var params = {
        code: this.form.code,
        name: this.form.name,
        branch_code: this.form.branch_code,
        region_code: this.form.region_code,
        outlet_type: this.form.outlet_type,
        latitude: this.form.latitude,
        longitude: this.form.longitude,
        address: this.form.address,
        is_active: this.form.is_active,
      };
      this.loading = true;
      var self = this;
      outlets
        .add(params)
        .then(function (response) {
          self.loading = false;
          self.$parent.dialogFormAddVisible = false;
          self.$parent.fetch();
          // console.log(response);
          self.$message({
            type: "success",
            message: response.data.message,
          });
        })
        .catch(function (error) {
          self.loading = false;
          // console.log(error);
          self.$message({
            type: "error",
            message: error.response.data.message,
          });
          if (error.response.status == 403) {
            self.logout();
          }
        });
    },
    updateOutlet() {
      var params = {
        name: this.form.name,
        branch_code: this.form.branch_code,
        region_code: this.form.region_code,
        outlet_type: this.form.outlet_type,
        latitude: this.form.latitude,
        longitude: this.form.longitude,
        address: this.form.address,
        is_active: this.form.is_active,
      };
      this.loading = true;
      var self = this;
      outlets
        .update(this.form.code, params)
        .then(function (response) {
          self.loading = false;
          self.$parent.dialogFormAddVisible = false;
          self.$parent.fetch();
          // console.log(response);
          self.$message({
            type: "success",
            message: response.data.message,
          });
        })
        .catch(function (error) {
          self.loading = false;
          // console.log(error);
          self.$message({
            type: "error",
            message: error.response.data.message,
          });
          if (error.response.status == 403) {
            self.logout();
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
